import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button, Grid } from "@material-ui/core";

import SaveIcon from "@material-ui/icons/Save";
import CancelIcon from "@material-ui/icons/Cancel";
import { TextValidator, ValidatorForm } from "react-material-ui-form-validator";
import { useForm } from "../../../hooks/useForm";

const useStyles = makeStyles({
    botonera: {
        padding: 25
    }
});

export const FormTopes = (props) => {
    const classes = useStyles();
    const { topesMinimos } = props

    const FormInicial = {
        periodoDesde: "",
        periodoHasta: "",
        importe: "",
        importeMinimo: "",
        nombreResolucion: ""
    }

    const [formValues, handleInputChange] = useForm(topesMinimos ? topesMinimos : FormInicial);

    const handleSave = (e) => {
        e.preventDefault()
        props.handleSave(formValues);
    };

    return (
        <ValidatorForm onSubmit={handleSave}>
            <Grid container style={{ padding: 25 }}>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Nombre Resolucion"
                        name="nombreResolucion"
                        value={formValues.nombreResolucion}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El nombre de la resolucion es requerido."]}
                    />
                </Grid>
                <Grid item xs={6} md={3}>
                    <TextValidator
                        margin="normal"
                        label="Importe Min."
                        name="importeMinimo"
                        value={formValues.importeMinimo}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El importe mínimo es requerido."]}
                        type="number"
                    />
                </Grid>
                <Grid item xs={6} md={3}>
                    <TextValidator
                        margin="normal"
                        label="Importe Max."
                        name="importe"
                        value={formValues.importe}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El importe máximo es requerido."]}
                        type="number"
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Periodo Desde AAAAMM"
                        name="periodoDesde"
                        value={formValues.periodoDesde}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El periodo desde es requerido."]}
                    />
                </Grid>
                <Grid item xs={12} md={6}>
                    <TextValidator
                        margin="normal"
                        label="Periodo Hasta AAAAMM"
                        name="periodoHasta"
                        value={formValues.periodoHasta}
                        autoComplete="off"
                        onChange={handleInputChange}
                        fullWidth
                        style={{ paddingRight: "0.5rem" }}
                        validators={["required"]}
                        errorMessages={["El periodo hasta es requerido."]}
                    />
                </Grid>
                <Grid container className={classes.botonera} >
                    <Grid item xs={12}>
                        <Grid
                            container
                            spacing={1}
                            direction="row"
                            justify="flex-end"
                            alignItems="center"
                        >
                            <Button
                                variant="contained"
                                color="secondary"
                                size="small"
                                startIcon={<CancelIcon />}
                                onClick={props.cerrarModal}
                            >
                                CANCELAR
                            </Button>
                            {
                                <Button
                                    variant="contained"
                                    color="primary"
                                    size="small"
                                    startIcon={<SaveIcon />}
                                    type='submit'
                                    style={{ marginLeft: "0.5rem" }}
                                    onClick={props.cerrarModal}
                                >
                                    GUARDAR
                                </Button>
                            }
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </ValidatorForm>
    );
};